import React from "react";
import { Grid, Typography } from "@material-ui/core";
import { Spinner } from "./Spinner";

export function AuthLoadingScreen() {
	return (
		<Grid
			container
			spacing={8}
			style={{
				minHeight: "60vh",
				alignItems: "center",
				justifyContent: "center"
			}}
		>
			<Grid item xs={12} style={{ textAlign: "center" }}>
				<Spinner size={60} />
				<Typography variant="h6" style={{ marginTop: 20 }}>
					Loading...
				</Typography>
			</Grid>
		</Grid>
	);
}
